export enum UserType {
    Model = 'model',
    User = 'user',
    None = 'none',
}

export enum PlayerType {
    Player = 'player',
    Broadcaster = 'broadcaster',
}

export enum RegSource {
    Unknown = 'unknown',
    Google = 'google',
    GoogleOneTap = 'one_tap',
    Twitter = 'twitter',
    Email = 'email',
}

export enum SignupContext {
    AddToFavorites = 'add_to_favorites',
    StoriesLimit = 'stories_limit',
    StoriesReport = 'stories_report',
    Main = 'main',
    Login = 'login',
    UnauthorizedStart = 'unauthorized_start',
    Page = 'page',
}

export type SignupContextDetails = {
    storyId?: string;
}

export enum StatusType {
    Unknown = 'unknown',
    Search = 'search',
    Room = 'room',
}

export enum EventType {
    GdprModalShow = 'gdpr_modal_show',
    GdprClickAccept = 'gdpr_click_accept',
    LoginSuccess = 'login_success',
    LoginError = 'login_error',
    RegistrationSuccess = 'registration_success',
    RegistrationError = 'registration_error',
    RegistrationHeaderFlowClickGender = 'registration_header_flow_click_gender',
    VerificationSendLink = 'verification_send_link',
    VerificationSuccess = 'verification_success',
    CameraPermissionModalShow = 'camera_permission_modal_show',
    CameraPermissionModalAccept = 'camera_permission_modal_accept',
    CameraPermissionModalDecline = 'camera_permission_modal_decline',
    CameraPermissionStateShow = 'camera_permission_state_show',
    RoomModelEndChat = 'room_model_end_chat',
    RoomModelClickStartChat = 'room_model_click_start_chat',
    RoomUserClickStartChat = 'room_user_click_start_chat',
    ClickFindMatch = 'click_find_match',
    ClickStartCall = 'click_start_call',
    RoomUserCreated = 'room_user_created',
    RoomUserSearch = 'room_user_search',
    StreamNotReceived = 'stream_not_received',
    StreamReceived = 'stream_received',
    MaleStreamNotReceived = 'male_stream_not_received',
    StreamNotReceivedStop = 'stream_not_received_stop',
    RoomModelSearch = 'room_model_search',
    RoomUserNoneChat = 'room_user_none_chat',
    RoomUserClickNextChat = 'room_user_click_next_chat',
    RoomUserClickStopChat = 'room_user_click_stop_chat',
    RoomUserModalLangShow = 'room_user_modal_lang_show',
    RoomUserModalLangClickStart = 'room_user_modal_lang_click_start',
    RoomUserModalLangClickCancel = 'room_user_modal_lang_click_cancel',
    RoomUserModalRulesShow = 'room_user_modal_rules_show',
    RoomUserModalRulesAccept = 'room_user_modal_rules_accept',
    RoomUserModalRulesClose = 'room_user_modal_rules_close',
    PaymentsSuccess = 'payments_success',
    PaymentsClickContinue = 'payments_click_continue',
    PaymentsClickClose = 'payments_click_close',
    PaymentsModalShow = 'payments_modal_show',
    PaymentsEndBalance = 'payments_end_balance',
    PaymentsModalShowError = 'payments_modal_show_error',
    PaymentsBillingError = 'payments_billing_error',
    PaymentsCancelSubscriptionShow = 'payments_cancel_subscription_show',
    PaymentsCancelSubscriptionDone = 'payments_cancel_subscription_done',
    PlayerCanPlay = 'player_can_play',
    PlayerLoadStart = 'player_load_start',
    PlayerStart = 'player_start',
    PlayerSockedOpened = 'player_socked_opened',
    PlayerSpdReceived = 'player_spd_received',
    PlayerPeerConnection = 'player_peer_connection',
    UserStoppedSearch = 'user_stopped_search',
    StreamIsPreparing = 'stream_is_preparing',
    SomethingWentWrong = 'something_went_wrong',
    SomethingWentTryAgain = 'something_went_try_again',
    RoomUserClickGiftIcon = 'room_user_click_gift_icon',
    RoomModelClickGiftIcon = 'room_model_click_gift_icon',
    RoomUserSendGift = 'room_user_send_gift',
    RoomUserCloseGift = 'room_user_close_gift_request',
    RoomModelRequestGift = 'room_model_request_gift',
    RoomUserClickRequestedGiftIcon = 'room_user_click_requested_gift_icon',
    UserAddFavorites = 'user_add_favorites',
    AutoPaymentsOn = 'auto_payments_on',
    AutoPaymentsOff = 'auto_payments_off',
    AutoPaymentsOffModalShow = 'auto_payments_off_modal_show',
    AutoPaymentsModalKeepItOnClick  = 'auto_payments_modal_keep_it_on_click',
    AutoPaymentsModalDisableClick = 'auto_payments_modal_disable_click',
    AutoPaymentsModalCloseClick = 'auto_payments_modal_close_click',
    StatusUpdate = 'status_update',
    StreamMyPicIsBig = 'stream_my_pic_is_big',
    StreamMyPicIsSmall = 'stream_my_pic_is_small',
    HeaderLoginClick = 'header_login_click',
    MainButtonClickTryForFree = 'main_button_click_try_for_free',
    MainButtonClick = 'main_button_click',
    MainButtonClickMan = 'main_button_click_man',
    MainButtonClickWoman = 'main_button_click_woman',
    PartnerSearchErrorDuration = 'partner_search_error_duration_ms',
    RoomCreateErrorDuration = 'room_create_error_duration_ms',
    RoomLifetimeErrorDuration = 'room_lifetime_error_duration_ms',
    RatingModalShow = 'rating_modal_show',
    RatingModalClick = 'rating_modal_click',
    RatingSecondModalClick = 'rating_second_modal_click',
    RatingModalClickContinue = 'rating_modal_click_continue',
    RatingSecondModalClickContinue = 'rating_second_modal_click_continue',
    UserAccountDelete = 'user_account_delete',
    UserAccountDeleteError = 'user_account_delete_error',
    UserAccountDeactivate = 'user_account_deactivate',
    UserAccountDeactivateError = 'user_account_deactivate_error',
    VpnDetectedShow = 'vpn_detected_show',
    VpnDetectedClose = 'vpn_detected_close',
    UserUnsubscribedFavorites = 'user_unsubscribed_favorites',
    UserAccountUnsubscribe = 'user_account_unsubscribe',
    SelfInfoError = 'self_info_error',
    ModelStoriesClickUpload = 'model_stories_click_upload',
    ModelStoriesLetsGo = 'model_stories_lets_go',
    ModelStoriesOnboardingClosed = 'model_stories_onboarding_closed',
    ModelStoriesClickPublish = 'model_stories_click_publish',
    ModelStoriesClickRedo = 'model_stories_click_redo',
    ModelStoriesClickRedoContinue = 'model_stories_click_redo_continue',
    ModelStoriesApprove = 'model_stories_approve',
    ModelStoriesReject = 'model_stories_reject',
    ModelStoriesDelete = 'model_stories_delete',
    StoriesClickWatch = 'stories_click_watch',
    StoriesViewSuccess = 'stories_view_success',
    StoriesStart = 'stories_start',
    StoriesReport = 'stories_report',
    StoriesClose = 'stories_close',
    StoriesSoundOn = 'stories_sound_on',
    StoriesSoundOff = 'stories_sound_off',
    CallButtonClick = 'call_button_click',
    CallRoomPending = 'call_room_pending',
    Report = 'report',
    ChatHistory = 'impression_history_chat',
    PmSent = 'pm_sent',
    PmImpression = 'pm_impression',
    ConnectionLost = 'connection_lost',
    ConnectionLostTimeout = 'connection_lost_timeout',
    ConnectionLostRoomClosed = 'connection_lost_room_closed',
    ConnectionRestored = 'connection_restored',
    StreamingStats = 'streaming_stats',
    FrontendMetricsCapture = 'frontend_metrics_capture',
    ModelStoriesActive = 'model_stories_active',
    ModelStoriesInactive = 'model_stories_inactive',
}

export enum EventCategory {
    Gdpr = 'gdpr',
    Unknown = 'unknown',
    Registration = 'registration',
    Verification = 'verification',
    RoomModel = 'room_model',
    RoomUser = 'room_user',
    Payments = 'payments',
    Stream = 'stream',
    StreamProvider = 'stream_provider',
    RoomUserGift = 'room_user_gift',
    RoomModelGift = 'room_model_gift',
    Favorites = 'favorites',
    Status = 'status',
    Call = 'call',
    Login = 'login',
    AutoPayments = 'auto_payments',
    Rating = 'rating',
    Account = 'account',
    UserNotes = 'notes',
    Permissions = 'permissions',
    Stories = 'stories',
    Report = 'report',
    Controls = 'controls',
    Pm = 'pm',
    ConnectionLost = 'connection_lost',
    Streaming = 'streaming',
    FrontendMetrics = 'frontend_metrics'
}

export enum PaymentSource {
    ButtonStartChat = 'button_start_chat',
    AutoEndFreeBalance = 'auto_end_free_balance',
    AutoCheckFreeBalance = 'auto_check_free_balance',
    AutoEndPaidBalance = 'auto_end_paid_balance',
    ButtonBuyMembership = 'button_buy_membership',
    PmBuyMembership = 'buy_subscription_pm',
    PmWantToSend = 'user_want_to_send_pm',
    PmWantToRead = 'user_want_to_read_pm',
    ButtonBuyMinutes = 'button_buy_minutes',
    PaymentFailure = 'payment_failure',
    OffUserCamera = 'off_user_camera',
    OffUserMic = 'off_user_mic',
    OnUserCamera = 'on_user_camera',
    OnUserMic = 'on_user_mic',
    UserInitialGift = 'user_initiation_gift',
    ModelInitialGift = 'model_initiation_gift',
    Call = 'call',
    AutoPayments = 'auto_payments',
    VpnDetected = 'vpn_detected',
    Stories = 'stories',
    GiftsCarousel = 'gifts_carousel',
    Sale = 'spec_offer_banner',
}

export enum PaymentType {
    Membership = 'membership',
    ExtraMinutes = 'extra_minutes',
    Unknown = 'unknown',
}

export enum EndChatReason {
    ModelCameraOff = 'model_camera_off',
    ModeratorStop = 'moderator_stop',
    SessionExists = 'session_exists',
    ModelButton = 'model_button',
    ModelButtonBeforePlayerStarted = 'model_button_before_player_started',
    ModelButtonPlayerNotPlaying = 'model_button_player_not_playing',
    UserButton = 'user_button',
    UserButtonBeforePlayerStarted = 'user_button_before_player_started',
    UserButtonPlayerNotPlaying = 'user_button_player_not_playing',
    UserGoneAway = 'user_gone_away',
    UserGoneAwayBeforePlayerStarted  = 'user_gone_away_before_player_started',
    UserGoneAwayPlayerNotPlaying  = 'user_gone_away_player_not_playing',
    ModelGoneAway = 'model_gone_away',
    ModelGoneAwayBeforePlayerStarted  = 'model_gone_away_before_player_started',
    ModelGoneAwayPlayerNotPlaying  = 'model_gone_away_player_not_playing',
    RoomTimeout = 'room_timeout',
    RoomStreamNotStarted = 'room_stream_not_started',
    RoomStreamNotStartedTimeout = 'room_stream_not_started_timeout',
    ModelSkipped = 'model_skipped',
    ModelSkippedBeforePlayerStarted  = 'model_skipped_before_player_started',
    ModelSkippedPlayerNotPlaying  = 'model_skipped_player_not_playing',
    UserSkipped = 'user_skipped',
    UserSkippedBeforePlayerStarted  = 'user_skipped_before_video_started',
    UserSkippedPlayerNotPlaying  = 'user_skipped_player_not_playing',
    UserBalance = 'user_balance',
    UserBlocked = 'user_blocked',
    PermissionsRevoked = 'permissions_revoked',
    AutoModerationStop = 'automoderation_stop',
    FreeTimePackage =  'free_time_package',
    PlayerError =  'player_error',
    NoAnswer =  'calls_no_naswer',
    CrossCallInterrupt =  'calls_call_interrupt',
    ModelUnstableConnection = 'model_unstable_connection',
    UserUnstableConnection = 'user_unstable_connection'
}

export enum CallContext {
    Stories = 'stories',
    Favorites = 'favorites',
    ChatHistory = 'chat_history',
    Direct = 'direct',
    Pm = 'pm',
}

export enum GiftPlace {
    Chat = 'chat',
    Pm = 'pm',
    RatingModal = 'rating_modal',
    GiftsCarousel = 'gifts_carousel',
}

export enum PmPlace {
    Menu = 'menu',
    Favorites = 'favorites',
}

export enum SearchContext {
    ClickFindMatch = 'click_find_match',
}

export enum UserAccountUnsubscribeVariant {
    StaySubscribed = 'stay_subscribed',
    FromModel = 'from_model',
    FromAllFavorites = 'from_all_favorites',
}
